export default "__VITE_ASSET__UJZ6jPxa__"